export default "/images/sort-both.svg?c503d7c748a054106d5db7108fe91167";